import request from '@/utils/request'


// 查询商家列表
export function listMerchant(query) {
  return request({
    url: '/merchant/merchant/list',
    method: 'get',
    params: query
  })
}

// 查询商家分页
export function pageMerchant(query) {
  return request({
    url: '/merchant/merchant/page',
    method: 'get',
    params: query
  })
}
export function tiaozhuan(data) {
  return request({
    url: '/merchant/merchant/tiaozhuan',
    method: 'get',
    params: data
  })
}
export function tiaozhuan1(data) {
  return request({
    url: '/merchant/merchant/tiaozhuan1',
    method: 'get',
    params: data
  })
}

// 查询商家详细
export function getMerchant(data) {
  return request({
    url: '/merchant/merchant/detail',
    method: 'get',
    params: data
  })
}

// 新增商家
export function addMerchant(data) {
  return request({
    url: '/merchant/merchant/add',
    method: 'post',
    data: data
  })
}

// 修改商家
export function updateMerchant(data) {
  return request({
    url: '/merchant/merchant/edit',
    method: 'post',
    data: data
  })
}

// 删除商家
export function delMerchant(data) {
  return request({
    url: '/merchant/merchant/delete',
    method: 'post',
    data: data
  })
}
